import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/**
 * Logs the project's photo viewer opening, the event the product gallery sends
 * when its viewer opens, keyed on the project as that one is on the product.
 * Every surface that opens the viewer — the banner, the gallery's photographs
 * and the grid's cells — calls this as it opens it.
 */
export const useTrackPhotoViewerOpen = (projectId: number) => {
    const tracker = useTracker();
    return useCallback(() => {
        void tracker.log('PhotoViewerTrigger', {
            url: new URL(window.location.href),
            data: { LibraryItemID: projectId },
        });
    }, [tracker, projectId]);
};
